import storage from 'store'
import { API_unReadCount, API_allRead, API_infoRead } from '@/api/userList.js'
import expirePlugin from 'store/plugins/expire'
import { message } from 'ant-design-vue'
storage.addPlugin(expirePlugin)
const messageCenter = {
  state: {
    messageType: 'notices',
    messageCenterData: [
      // { key: 'official', title: '官方', count: 2, messageType: 'official' },
      { key: 'notices', title: '通知', count: 0, messageType: 'notices' },
      // { key: 'message', title: '私信', count: 4, messageType: 'message' },
      // { key: 'blackList', title: '黑名单', count: 8, messageType: 'blackList' },
    ],
    allCount: 0,
    showMessagePop: false,
  },

  mutations: {
    CHANGE_MESSAGETYPE: (state, messageType) => {
      state.messageType = messageType
    },
    SET_ALL_COUNT: (state, allCount) => {
      state.allCount = allCount
    },
    CHANGE_SHOW_MESSAGEPOP: (state, showMessagePop) => {
      state.showMessagePop = showMessagePop
    },
  },
  actions: {
    getMessageCenterData: ({ state }) => {
      API_unReadCount().then((res) => {
        state.messageCenterData.forEach((item) => {
          // if (item.key == 'official') item.count = res.data
          if (item.key == 'notices') item.count = res.data
          // if (item.key == 'message') item.count = 3
          // if (item.key == 'all') item.count = 4
        })
      })
    },
    handleAllRead: ({ state }) => {
      return new Promise((resolve, reject) => {
        API_allRead()
          .then((res) => {
            state.messageCenterData.forEach((item) => {
              item.count = 0
            })
            resolve(res)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    handleInfoRead({ state }, id) {
      return new Promise((resolve, reject) => {
        const params = { messageIds: id || [] }
        API_infoRead(params)
          .then((res) => {
            console.log('readRes', params)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
  getters: {},
}

export default messageCenter
